import { Icon } from "@chakra-ui/react";

export default function Youtube({ ...props }) {
  return (
    <Icon width="32" height="32" viewBox="0 0 32 32" {...props}>
      <g fill="currentColor">
        <path d="M15.98 0C7.155 0 0 7.155 0 15.98s7.155 15.98 15.98 15.98 15.98-7.155 15.98-15.98C31.96 7.153 24.805 0 15.98 0zm9.818 19.558c-.108 1.33-1.119 3.028-2.531 3.273-4.524.352-9.886.308-14.572 0-1.462-.183-2.423-1.945-2.53-3.273-.228-2.793-.228-4.383 0-7.176.107-1.328 1.092-3.08 2.53-3.24 4.632-.389 10.024-.305 14.572 0 1.626.06 2.423 1.736 2.53 3.067.224 2.792.224 4.556 0 7.349z" />
        <path d="M13.982 19.975L19.975 15.98 13.982 11.985z" />
      </g>
    </Icon>
  );
}
